export const constants = {
  locales: ["en", "hi", "gu"],
  deviceTypes: ["mobile", "web"],
  renderingTypes: ["isr", "csr"],
};

export const seoConfig = {
  title: ["title"],
  meta: ["title", "description", "keywords"],
  openGraph: ["siteName", "title", "description", "images", "url"],
  twitter: ["siteName", "title", "description", "images", "url"],
};

export const locales: any = {
  en: "English",
  gu: "Gujarati",
  hi: "Hindi",
};

export const globalRegex: any = {
  ONLY_SIX_DIGIT: /^\d{0,6}$/,
  SIX_DIGIT: /^\d{6}$/,
  MAX_TEN_DIGIT: /^\d{0,10}$/,
  MOBILE_NUMBER: /^\d{10,10}$/,
  VALID_MOBILE_NUMBER: /^[6-9]\d{9}$/,
  PINCODE: /^[1-9]\d{5}$/,
  ADDRESSTYPE: /^(home|other|work)$/,
  EMAIL: /^$|^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  ADDRESS: /^[a-zA-Z0-9\s,]{0,250}$/,
  ADDRESS2: /^[a-zA-Z0-9\s,-]{0,150}$/,
  LANDMARK: /^[a-zA-Z0-9\s,]{0,150}$/,
  NAME: /^[a-zA-Z0-9\s,]{0,150}$/,
};

export const OnlineOrderCityMapping = {
  ahmedabad: { city_name: "Ahmedabad", city_slug: "ahmedabad" },
  bengaluru: { city_name: "Bengaluru", city_slug: "bengaluru" },
  vadodara: { city_name: "Vadodara", city_slug: "vadodara" },
  mumbai: { city_name: "Mumbai", city_slug: "mumbai" },
  pune: { city_name: "Pune", city_slug: "pune" },
  thane: { city_name: "Thane", city_slug: "thane" },
  hyderabad: { city_name: "Hyderabad", city_slug: "hyderabad" },
  gurgaon: { city_name: "Gurgaon", city_slug: "gurgaon" },
  jaipur: { city_name: "Jaipur", city_slug: "jaipur" },
  kolkata: { city_name: "Kolkata", city_slug: "kolkata" },
  "gautam-buddha-nagar": {
    city_name: "Gautam Buddha Nagar",
    city_slug: "gautam-buddha-nagar",
  },
  "Delhi": {
    city_name: "Delhi",
    city_slug: "delhi",
  },
  chennai: { city_name: "Chennai", city_slug: "chennai" },
  lucknow: { city_name: "Lucknow", city_slug: "lucknow" },
  "north-24-parganas": {
    city_name: "North 24 Parganas",
    city_slug: "north-24-parganas",
  },
  nagpur: { city_name: "Nagpur", city_slug: "nagpur" },
  gandhinagar: { city_name: "Gandhinagar", city_slug: "gandhinagar" },
  coimbatore: { city_name: "Coimbatore", city_slug: "coimbatore" },
  bhopal: { city_name: "Bhopal", city_slug: "bhopal" },
  ghaziabad: { city_name: "Ghaziabad", city_slug: "ghaziabad" },
  rajkot: { city_name: "Rajkot", city_slug: "rajkot" },
  surat: { city_name: "Surat", city_slug: "surat" },
  kanchipuram: { city_name: "Kanchipuram", city_slug: "kanchipuram" },
  faridabad: { city_name: "Faridabad", city_slug: "faridabad" },
  indore: { city_name: "Indore", city_slug: "indore" },
  mohali: { city_name: "Mohali", city_slug: "mohali" },
  "south-24-parganas": {
    city_name: "South 24 Parganas",
    city_slug: "south-24-parganas",
  },
  valsad: { city_name: "Valsad", city_slug: "valsad" },
  patna: { city_name: "Patna", city_slug: "patna" },
  bharuch: { city_name: "Bharuch", city_slug: "bharuch" },
  raigarh: { city_name: "Raigarh", city_slug: "raigarh" },
  dehradun: { city_name: "Dehradun", city_slug: "dehradun" },
  anand: { city_name: "Anand", city_slug: "anand" },
  chandigarh: { city_name: "Chandigarh", city_slug: "chandigarh" },
  ludhiana: { city_name: "Ludhiana", city_slug: "ludhiana" },
  jammu: { city_name: "Jammu", city_slug: "jammu" },
  kanpur: { city_name: "Kanpur", city_slug: "kanpur" },
  kachchh: { city_name: "Kachchh", city_slug: "kachchh" },
  varanasi: { city_name: "Varanasi", city_slug: "varanasi" },
  "kv-rangareddy": { city_name: "KV Rangareddy", city_slug: "kv-rangareddy" },
  udaipur: { city_name: "Udaipur", city_slug: "udaipur" },
  "kamrup-assam": { city_name: "Kamrup Assam", city_slug: "kamrup-assam" },
  kota: { city_name: "Kota", city_slug: "kota" },
  jodhpur: { city_name: "Jodhpur", city_slug: "jodhpur" },
  visakhapatnam: { city_name: "Visakhapatnam", city_slug: "visakhapatnam" },
  jamnagar: { city_name: "Jamnagar", city_slug: "jamnagar" },
  ujjain: { city_name: "Ujjain", city_slug: "ujjain" },
  ajmer: { city_name: "Ajmer", city_slug: "ajmer" },
  patiala: { city_name: "Patiala", city_slug: "patiala" },
  howrah: { city_name: "Howrah", city_slug: "howrah" },
  nashik: { city_name: "Nashik", city_slug: "nashik" },
  bhavnagar: { city_name: "Bhavnagar", city_slug: "bhavnagar" },
  bareilly: { city_name: "Bareilly", city_slug: "bareilly" },
  hooghly: { city_name: "Hooghly", city_slug: "hooghly" },
  allahabad: { city_name: "Allahabad", city_slug: "allahabad" },
  khorda: { city_name: "Khorda", city_slug: "khorda" },
  tiruvallur: { city_name: "Tiruvallur", city_slug: "tiruvallur" },
  kangra: { city_name: "Kangra", city_slug: "kangra" },
  surendranagar: { city_name: "Surendranagar", city_slug: "surendranagar" },
  ambala: { city_name: "Ambala", city_slug: "ambala" },
  dahod: { city_name: "Dahod", city_slug: "dahod" },
  banaskantha: { city_name: "Banaskantha", city_slug: "banaskantha" },
  ernakulam: { city_name: "Ernakulam", city_slug: "ernakulam" },
  "south-goa": { city_name: "South Goa", city_slug: "south-goa" },
  mahesana: { city_name: "Mahesana", city_slug: "mahesana" },
  "panch-mahals": { city_name: "Panch Mahals", city_slug: "panch-mahals" },
  belagavi: { city_name: "Belagavi", city_slug: "belagavi" },
  vellore: { city_name: "Vellore", city_slug: "vellore" },
  guntur: { city_name: "Guntur", city_slug: "guntur" },
  chittorgarh: { city_name: "Chittorgarh", city_slug: "chittorgarh" },
  banswara: { city_name: "Banswara", city_slug: "banswara" },
  "purba-bardhaman": {
    city_name: "Purba Bardhaman",
    city_slug: "purba-bardhaman",
  },
  meerut: { city_name: "Meerut", city_slug: "meerut" },
  raipur: { city_name: "Raipur", city_slug: "raipur" },
  aurangabad: { city_name: "Aurangabad", city_slug: "aurangabad" },
  nadia: { city_name: "Nadia", city_slug: "nadia" },
  krishna: { city_name: "Krishna", city_slug: "krishna" },
  ranchi: { city_name: "Ranchi", city_slug: "ranchi" },
  bangalore: { city_name: "Bangalore", city_slug: "bangalore" },
  madurai: { city_name: "Madurai", city_slug: "madurai" },
  chamba: { city_name: "Chamba", city_slug: "chamba" },
  "north-goa": { city_name: "North Goa", city_slug: "north-goa" },
  tiruchirappalli: {
    city_name: "Tiruchirappalli",
    city_slug: "tiruchirappalli",
  },
  jalgaon: { city_name: "Jalgaon", city_slug: "jalgaon" },
  thiruvananthapuram: {
    city_name: "Thiruvananthapuram",
    city_slug: "thiruvananthapuram",
  },
  sonipat: { city_name: "Sonipat", city_slug: "sonipat" },
  junagadh: { city_name: "Junagadh", city_slug: "junagadh" },
  "east-godavari": { city_name: "East Godavari", city_slug: "east-godavari" },
  amreli: { city_name: "Amreli", city_slug: "amreli" },
  ananthapur: { city_name: "Ananthapur", city_slug: "ananthapur" },
  srinagar: { city_name: "Srinagar", city_slug: "srinagar" },
  gorakhpur: { city_name: "Gorakhpur", city_slug: "gorakhpur" },
  sabarkantha: { city_name: "Sabarkantha", city_slug: "sabarkantha" },
  sikar: { city_name: "Sikar", city_slug: "sikar" },
  muzaffarpur: { city_name: "Muzaffarpur", city_slug: "muzaffarpur" },
  agra: { city_name: "Agra", city_slug: "agra" },
  bhagalpur: { city_name: "Bhagalpur", city_slug: "bhagalpur" },
  dhanbad: { city_name: "Dhanbad", city_slug: "dhanbad" },
  jaunpur: { city_name: "Jaunpur", city_slug: "jaunpur" },
  "west-midnapore": {
    city_name: "West Midnapore",
    city_slug: "west-midnapore",
  },
  alwar: { city_name: "Alwar", city_slug: "alwar" },
  "west-godavari": { city_name: "West Godavari", city_slug: "west-godavari" },
  kheda: { city_name: "Kheda", city_slug: "kheda" },
  jalandhar: { city_name: "Jalandhar", city_slug: "jalandhar" },
  murshidabad: { city_name: "Murshidabad", city_slug: "murshidabad" },
  aligarh: { city_name: "Aligarh", city_slug: "aligarh" },
  amritsar: { city_name: "Amritsar", city_slug: "amritsar" },
  "east-singhbhum": {
    city_name: "East Singhbhum",
    city_slug: "east-singhbhum",
  },
  panipat: { city_name: "Panipat", city_slug: "panipat" },
  solapur: { city_name: "Solapur", city_slug: "solapur" },
  darjiling: { city_name: "Darjiling", city_slug: "darjiling" },
  birbhum: { city_name: "Birbhum", city_slug: "birbhum" },
  sangli: { city_name: "Sangli", city_slug: "sangli" },
  moradabad: { city_name: "Moradabad", city_slug: "moradabad" },
  "east-champaran": {
    city_name: "East Champaran",
    city_slug: "east-champaran",
  },
  darbhanga: { city_name: "Darbhanga", city_slug: "darbhanga" },
  chittoor: { city_name: "Chittoor", city_slug: "chittoor" },
  navsari: { city_name: "Navsari", city_slug: "navsari" },
  nagaur: { city_name: "Nagaur", city_slug: "nagaur" },
  durg: { city_name: "Durg", city_slug: "durg" },
  medak: { city_name: "Medak", city_slug: "medak" },
  mathura: { city_name: "Mathura", city_slug: "mathura" },
  "east-midnapore": {
    city_name: "East Midnapore",
    city_slug: "east-midnapore",
  },
  cuddapah: { city_name: "Cuddapah", city_slug: "cuddapah" },
  "paschim-bardhaman": {
    city_name: "Paschim Bardhaman",
    city_slug: "paschim-bardhaman",
  },
  kolhapur: { city_name: "Kolhapur", city_slug: "kolhapur" },
  alappuzha: { city_name: "Alappuzha", city_slug: "alappuzha" },
  sirohi: { city_name: "Sirohi", city_slug: "sirohi" },
  cuttack: { city_name: "Cuttack", city_slug: "cuttack" },
  gwalior: { city_name: "Gwalior", city_slug: "gwalior" },
  saran: { city_name: "Saran", city_slug: "saran" },
  ratnagiri: { city_name: "Ratnagiri", city_slug: "ratnagiri" },
  pali: { city_name: "Pali", city_slug: "pali" },
  azamgarh: { city_name: "Azamgarh", city_slug: "azamgarh" },
  yavatmal: { city_name: "Yavatmal", city_slug: "yavatmal" },
  samastipur: { city_name: "Samastipur", city_slug: "samastipur" },
  jabalpur: { city_name: "Jabalpur", city_slug: "jabalpur" },
  mysuru: { city_name: "Mysuru", city_slug: "mysuru" },
  "udham-singh-nagar": {
    city_name: "Udham Singh Nagar",
    city_slug: "udham-singh-nagar",
  },
  "ahmed-nagar": { city_name: "Ahmed Nagar", city_slug: "ahmed-nagar" },
  muzaffarnagar: { city_name: "Muzaffarnagar", city_slug: "muzaffarnagar" },
  gaya: { city_name: "Gaya", city_slug: "gaya" },
  dungarpur: { city_name: "Dungarpur", city_slug: "dungarpur" },
  siwan: { city_name: "Siwan", city_slug: "siwan" },
  barmer: { city_name: "Barmer", city_slug: "barmer" },
  satara: { city_name: "Satara", city_slug: "satara" },
  kozhikode: { city_name: "Kozhikode", city_slug: "kozhikode" },
  "north-dinajpur": {
    city_name: "North Dinajpur",
    city_slug: "north-dinajpur",
  },
  bankura: { city_name: "Bankura", city_slug: "bankura" },
  kurnool: { city_name: "Kurnool", city_slug: "kurnool" },
  haridwar: { city_name: "Haridwar", city_slug: "haridwar" },
  nanded: { city_name: "Nanded", city_slug: "nanded" },
  bhilwara: { city_name: "Bhilwara", city_slug: "bhilwara" },
  ganjam: { city_name: "Ganjam", city_slug: "ganjam" },
  jhansi: { city_name: "Jhansi", city_slug: "jhansi" },
  ghazipur: { city_name: "Ghazipur", city_slug: "ghazipur" },
  baleswar: { city_name: "Baleswar", city_slug: "baleswar" },
  nagaon: { city_name: "Nagaon", city_slug: "nagaon" },
  sultanpur: { city_name: "Sultanpur", city_slug: "sultanpur" },
  ballia: { city_name: "Ballia", city_slug: "ballia" },
  jalor: { city_name: "Jalor", city_slug: "jalor" },
  saharanpur: { city_name: "Saharanpur", city_slug: "saharanpur" },
  buldhana: { city_name: "Buldhana", city_slug: "buldhana" },
  rohtak: { city_name: "Rohtak", city_slug: "rohtak" },
  satna: { city_name: "Satna", city_slug: "satna" },
  shimla: { city_name: "Shimla", city_slug: "shimla" },
  "west-champaran": {
    city_name: "West Champaran",
    city_slug: "west-champaran",
  },
  madhubani: { city_name: "Madhubani", city_slug: "madhubani" },
  panchkula: { city_name: "Panchkula", city_slug: "panchkula" },
  jhujhunu: { city_name: "Jhujhunu", city_slug: "jhujhunu" },
  bikaner: { city_name: "Bikaner", city_slug: "bikaner" },
  dharwad: { city_name: "Dharwad", city_slug: "dharwad" },
  daman: { city_name: "Daman", city_slug: "daman" },
  gurdaspur: { city_name: "Gurdaspur", city_slug: "gurdaspur" },
  "bilaspur-cgh": { city_name: "Bilaspur(Cgh)", city_slug: "bilaspur-cgh" },
  malda: { city_name: "Malda", city_slug: "malda" },
  churu: { city_name: "Churu", city_slug: "churu" },
  patan: { city_name: "Patan", city_slug: "patan" },
  hoshiarpur: { city_name: "Hoshiarpur", city_slug: "hoshiarpur" },
  dhar: { city_name: "Dhar", city_slug: "dhar" },
  cachar: { city_name: "Cachar", city_slug: "cachar" },
  amravati: { city_name: "Amravati", city_slug: "amravati" },
  etah: { city_name: "Etah", city_slug: "etah" },
  "dadra-nagar-haveli": {
    city_name: "Dadra & Nagar Haveli",
    city_slug: "dadra-nagar-haveli",
  },
  rajsamand: { city_name: "Rajsamand", city_slug: "rajsamand" },
  ratlam: { city_name: "Ratlam", city_slug: "ratlam" },
  sagar: { city_name: "Sagar", city_slug: "sagar" },
  kollam: { city_name: "Kollam", city_slug: "kollam" },
  ballari: { city_name: "Ballari", city_slug: "ballari" },
  "karim-nagar": { city_name: "Karim Nagar", city_slug: "karim-nagar" },
  nellore: { city_name: "Nellore", city_slug: "nellore" },
  ananthnag: { city_name: "Ananthnag", city_slug: "ananthnag" },
  jhajjar: { city_name: "Jhajjar", city_slug: "jhajjar" },
  bahraich: { city_name: "Bahraich", city_slug: "bahraich" },
  pratapgarh: { city_name: "Pratapgarh", city_slug: "pratapgarh" },
  solan: { city_name: "Solan", city_slug: "solan" },
  gopalganj: { city_name: "Gopalganj", city_slug: "gopalganj" },
  unnao: { city_name: "Unnao", city_slug: "unnao" },
  firozpur: { city_name: "Firozpur", city_slug: "firozpur" },
  baramulla: { city_name: "Baramulla", city_slug: "baramulla" },
  chandrapur: { city_name: "Chandrapur", city_slug: "chandrapur" },
  bijnor: { city_name: "Bijnor", city_slug: "bijnor" },
  "west-tripura": { city_name: "West Tripura", city_slug: "west-tripura" },
  bharatpur: { city_name: "Bharatpur", city_slug: "bharatpur" },
  raebareli: { city_name: "Raebareli", city_slug: "raebareli" },
  nalanda: { city_name: "Nalanda", city_slug: "nalanda" },
  "ambedkar-nagar": {
    city_name: "Ambedkar Nagar",
    city_slug: "ambedkar-nagar",
  },
  erode: { city_name: "Erode", city_slug: "erode" },
  vaishali: { city_name: "Vaishali", city_slug: "vaishali" },
  katihar: { city_name: "Katihar", city_slug: "katihar" },
  sundergarh: { city_name: "Sundergarh", city_slug: "sundergarh" },
  deoria: { city_name: "Deoria", city_slug: "deoria" },
  khammam: { city_name: "Khammam", city_slug: "khammam" },
  bokaro: { city_name: "Bokaro", city_slug: "bokaro" },
  bulandshahr: { city_name: "Bulandshahr", city_slug: "bulandshahr" },
  porbandar: { city_name: "Porbandar", city_slug: "porbandar" },
  thrissur: { city_name: "Thrissur", city_slug: "thrissur" },
  pondicherry: { city_name: "Pondicherry", city_slug: "pondicherry" },
  araria: { city_name: "Araria", city_slug: "araria" },
  prakasam: { city_name: "Prakasam", city_slug: "prakasam" },
  warangal: { city_name: "Warangal", city_slug: "warangal" },
  "dakshina-kannada": {
    city_name: "Dakshina Kannada",
    city_slug: "dakshina-kannada",
  },
  palakkad: { city_name: "Palakkad", city_slug: "palakkad" },
  kalaburagi: { city_name: "Kalaburagi", city_slug: "kalaburagi" },
  malappuram: { city_name: "Malappuram", city_slug: "malappuram" },
  nainital: { city_name: "Nainital", city_slug: "nainital" },
  gonda: { city_name: "Gonda", city_slug: "gonda" },
  purnia: { city_name: "Purnia", city_slug: "purnia" },
  sangrur: { city_name: "Sangrur", city_slug: "sangrur" },
  thanjavur: { city_name: "Thanjavur", city_slug: "thanjavur" },
  hazaribag: { city_name: "Hazaribag", city_slug: "hazaribag" },
  mirzapur: { city_name: "Mirzapur", city_slug: "mirzapur" },
  sitamarhi: { city_name: "Sitamarhi", city_slug: "sitamarhi" },
  kottayam: { city_name: "Kottayam", city_slug: "kottayam" },
  krishnagiri: { city_name: "Krishnagiri", city_slug: "krishnagiri" },
  mandsaur: { city_name: "Mandsaur", city_slug: "mandsaur" },
  "east-khasi-hills": {
    city_name: "East Khasi Hills",
    city_slug: "east-khasi-hills",
  },
  jalpaiguri: { city_name: "Jalpaiguri", city_slug: "jalpaiguri" },
  munger: { city_name: "Munger", city_slug: "munger" },
  ganganagar: { city_name: "Ganganagar", city_slug: "ganganagar" },
  dhule: { city_name: "Dhule", city_slug: "dhule" },
  bhadrak: { city_name: "Bhadrak", city_slug: "bhadrak" },
  nalgonda: { city_name: "Nalgonda", city_slug: "nalgonda" },
  kanyakumari: { city_name: "Kanyakumari", city_slug: "kanyakumari" },
  akola: { city_name: "Akola", city_slug: "akola" },
  "mahabub-nagar": { city_name: "Mahabub Nagar", city_slug: "mahabub-nagar" },
  adilabad: { city_name: "Adilabad", city_slug: "adilabad" },
  palamau: { city_name: "Palamau", city_slug: "palamau" },
  nizamabad: { city_name: "Nizamabad", city_slug: "nizamabad" },
  pathanamthitta: { city_name: "Pathanamthitta", city_slug: "pathanamthitta" },
  faizabad: { city_name: "Faizabad", city_slug: "faizabad" },
  supaul: { city_name: "Supaul", city_slug: "supaul" },
  latur: { city_name: "Latur", city_slug: "latur" },
  dimapur: { city_name: "Dimapur", city_slug: "dimapur" },
  "south-dinajpur": {
    city_name: "South Dinajpur",
    city_slug: "south-dinajpur",
  },
  "west-nimar": { city_name: "West Nimar", city_slug: "west-nimar" },
  kushinagar: { city_name: "Kushinagar", city_slug: "kushinagar" },
  rewa: { city_name: "Rewa", city_slug: "rewa" },
  kannur: { city_name: "Kannur", city_slug: "kannur" },
  bhojpur: { city_name: "Bhojpur", city_slug: "bhojpur" },
  etawah: { city_name: "Etawah", city_slug: "etawah" },
  hanumangarh: { city_name: "Hanumangarh", city_slug: "hanumangarh" },
  bathinda: { city_name: "Bathinda", city_slug: "bathinda" },
  sirsa: { city_name: "Sirsa", city_slug: "sirsa" },
  "janjgir-champa": {
    city_name: "Janjgir-Champa",
    city_slug: "janjgir-champa",
  },
  hamirpur: { city_name: "Hamirpur", city_slug: "hamirpur" },
  kurukshetra: { city_name: "Kurukshetra", city_slug: "kurukshetra" },
  buxar: { city_name: "Buxar", city_slug: "buxar" },
  vidisha: { city_name: "Vidisha", city_slug: "vidisha" },
  basti: { city_name: "Basti", city_slug: "basti" },
  karnal: { city_name: "Karnal", city_slug: "karnal" },
  vizianagaram: { city_name: "Vizianagaram", city_slug: "vizianagaram" },
  aizawl: { city_name: "Aizawl", city_slug: "aizawl" },
  shahjahanpur: { city_name: "Shahjahanpur", city_slug: "shahjahanpur" },
  wardha: { city_name: "Wardha", city_slug: "wardha" },
  barpeta: { city_name: "Barpeta", city_slug: "barpeta" },
  pulwama: { city_name: "Pulwama", city_slug: "pulwama" },
  sonitpur: { city_name: "Sonitpur", city_slug: "sonitpur" },
  budgam: { city_name: "Budgam", city_slug: "budgam" },
  nandurbar: { city_name: "Nandurbar", city_slug: "nandurbar" },
  bhiwani: { city_name: "Bhiwani", city_slug: "bhiwani" },

  "alipurduar": {
    "city_name": "Alipurduar",
    "city_slug": "alipurduar"
  },
  "alirajpur": {
    "city_name": "Alirajpur",
    "city_slug": "alirajpur"
  },
  "almora": {
    "city_name": "Almora",
    "city_slug": "almora"
  },
  "angul": {
    "city_name": "Angul",
    "city_slug": "angul"
  },
  "anuppur": {
    "city_name": "Anuppur",
    "city_slug": "anuppur"
  },
  "ariyalur": {
    "city_name": "Ariyalur",
    "city_slug": "ariyalur"
  },
  "arwal": {
    "city_name": "Arwal",
    "city_slug": "arwal"
  },
  "ashok-nagar": {
    "city_name": "Ashok Nagar",
    "city_slug": "ashok-nagar"
  },
  "auraiya": {
    "city_name": "Auraiya",
    "city_slug": "auraiya"
  },
  "bagalkot": {
    "city_name": "Bagalkot",
    "city_slug": "bagalkot"
  },
  "bageshwar": {
    "city_name": "Bageshwar",
    "city_slug": "bageshwar"
  },
  "bagpat": {
    "city_name": "Bagpat",
    "city_slug": "bagpat"
  },
  "balaghat": {
    "city_name": "Balaghat",
    "city_slug": "balaghat"
  },
  "balangir": {
    "city_name": "Balangir",
    "city_slug": "balangir"
  },
  "balrampur": {
    "city_name": "Balrampur",
    "city_slug": "balrampur"
  },
  "banda": {
    "city_name": "Banda",
    "city_slug": "banda"
  },
  "bandipur": {
    "city_name": "Bandipur",
    "city_slug": "bandipur"
  },
  "bangalore-rural": {
    "city_name": "Bangalore Rural",
    "city_slug": "bangalore-rural"
  },
  "banka": {
    "city_name": "Banka",
    "city_slug": "banka"
  },
  "barabanki": {
    "city_name": "Barabanki",
    "city_slug": "barabanki"
  },
  "baran": {
    "city_name": "Baran",
    "city_slug": "baran"
  },
  "bargarh": {
    "city_name": "Bargarh",
    "city_slug": "bargarh"
  },
  "barnala": {
    "city_name": "Barnala",
    "city_slug": "barnala"
  },
  "barwani": {
    "city_name": "Barwani",
    "city_slug": "barwani"
  },
  "bastar": {
    "city_name": "Bastar",
    "city_slug": "bastar"
  },
  "beed": {
    "city_name": "Beed",
    "city_slug": "beed"
  },
  "begusarai": {
    "city_name": "Begusarai",
    "city_slug": "begusarai"
  },
  "betul": {
    "city_name": "Betul",
    "city_slug": "betul"
  },
  "bhandara": {
    "city_name": "Bhandara",
    "city_slug": "bhandara"
  },
  "bhind": {
    "city_name": "Bhind",
    "city_slug": "bhind"
  },
  "bidar": {
    "city_name": "Bidar",
    "city_slug": "bidar"
  },
  "bijapur": {
    "city_name": "Bijapur",
    "city_slug": "bijapur"
  },
  "bilaspur": {
    "city_name": "Bilaspur",
    "city_slug": "bilaspur"
  },
  "bishnupur": {
    "city_name": "Bishnupur",
    "city_slug": "bishnupur"
  },
  "bongaigaon": {
    "city_name": "Bongaigaon",
    "city_slug": "bongaigaon"
  },
  "boudh": {
    "city_name": "Boudh",
    "city_slug": "boudh"
  },
  "budaun": {
    "city_name": "Budaun",
    "city_slug": "budaun"
  },
  "bundi": {
    "city_name": "Bundi",
    "city_slug": "bundi"
  },
  "burdwan": {
    "city_name": "Burdwan",
    "city_slug": "burdwan"
  },
  "burhanpur": {
    "city_name": "Burhanpur",
    "city_slug": "burhanpur"
  },
  "chamoli": {
    "city_name": "Chamoli",
    "city_slug": "chamoli"
  },
  "champawat": {
    "city_name": "Champawat",
    "city_slug": "champawat"
  },
  "champhai": {
    "city_name": "Champhai",
    "city_slug": "champhai"
  },
  "chamrajnagar": {
    "city_name": "Chamrajnagar",
    "city_slug": "chamrajnagar"
  },
  "chandauli": {
    "city_name": "Chandauli",
    "city_slug": "chandauli"
  },
  "chandel": {
    "city_name": "Chandel",
    "city_slug": "chandel"
  },
  "changlang": {
    "city_name": "Changlang",
    "city_slug": "changlang"
  },
  "chatra": {
    "city_name": "Chatra",
    "city_slug": "chatra"
  },
  "chhatarpur": {
    "city_name": "Chhatarpur",
    "city_slug": "chhatarpur"
  },
  "chhindwara": {
    "city_name": "Chhindwara",
    "city_slug": "chhindwara"
  },
  "chikkaballapur": {
    "city_name": "Chikkaballapur",
    "city_slug": "chikkaballapur"
  },
  "chikkamagaluru": {
    "city_name": "Chikkamagaluru",
    "city_slug": "chikkamagaluru"
  },
  "chitradurga": {
    "city_name": "Chitradurga",
    "city_slug": "chitradurga"
  },
  "chitrakoot": {
    "city_name": "Chitrakoot",
    "city_slug": "chitrakoot"
  },
  "churachandpur": {
    "city_name": "Churachandpur",
    "city_slug": "churachandpur"
  },
  "cooch-behar": {
    "city_name": "Cooch Behar",
    "city_slug": "cooch-behar"
  },
  "cuddalore": {
    "city_name": "Cuddalore",
    "city_slug": "cuddalore"
  },
  "damoh": {
    "city_name": "Damoh",
    "city_slug": "damoh"
  },
  "dantewada": {
    "city_name": "Dantewada",
    "city_slug": "dantewada"
  },
  "darrang": {
    "city_name": "Darrang",
    "city_slug": "darrang"
  },
  "datia": {
    "city_name": "Datia",
    "city_slug": "datia"
  },
  "dausa": {
    "city_name": "Dausa",
    "city_slug": "dausa"
  },
  "davangere": {
    "city_name": "Davangere",
    "city_slug": "davangere"
  },
  "debagarh": {
    "city_name": "Debagarh",
    "city_slug": "debagarh"
  },
  "deoghar": {
    "city_name": "Deoghar",
    "city_slug": "deoghar"
  },
  "dewas": {
    "city_name": "Dewas",
    "city_slug": "dewas"
  },
  "dhalai": {
    "city_name": "Dhalai",
    "city_slug": "dhalai"
  },
  "dhamtari": {
    "city_name": "Dhamtari",
    "city_slug": "dhamtari"
  },
  "dharmapuri": {
    "city_name": "Dharmapuri",
    "city_slug": "dharmapuri"
  },
  "dhemaji": {
    "city_name": "Dhemaji",
    "city_slug": "dhemaji"
  },
  "dhenkanal": {
    "city_name": "Dhenkanal",
    "city_slug": "dhenkanal"
  },
  "dholpur": {
    "city_name": "Dholpur",
    "city_slug": "dholpur"
  },
  "dhubri": {
    "city_name": "Dhubri",
    "city_slug": "dhubri"
  },
  "dibang-valley": {
    "city_name": "Dibang Valley",
    "city_slug": "dibang-valley"
  },
  "dibrugarh": {
    "city_name": "Dibrugarh",
    "city_slug": "dibrugarh"
  },
  "dindigul": {
    "city_name": "Dindigul",
    "city_slug": "dindigul"
  },
  "dindori": {
    "city_name": "Dindori",
    "city_slug": "dindori"
  },
  "diu": {
    "city_name": "Diu",
    "city_slug": "diu"
  },
  "doda": {
    "city_name": "Doda",
    "city_slug": "doda"
  },
  "dumka": {
    "city_name": "Dumka",
    "city_slug": "dumka"
  },
  "east-garo-hills": {
    "city_name": "East Garo Hills",
    "city_slug": "east-garo-hills"
  },
  "east-kameng": {
    "city_name": "East Kameng",
    "city_slug": "east-kameng"
  },
  "east-nimar": {
    "city_name": "East Nimar",
    "city_slug": "east-nimar"
  },
  "east-siang": {
    "city_name": "East Siang",
    "city_slug": "east-siang"
  },
  "east-sikkim": {
    "city_name": "East Sikkim",
    "city_slug": "east-sikkim"
  },
  "faridkot": {
    "city_name": "Faridkot",
    "city_slug": "faridkot"
  },
  "farrukhabad": {
    "city_name": "Farrukhabad",
    "city_slug": "farrukhabad"
  },
  "fatehabad": {
    "city_name": "Fatehabad",
    "city_slug": "fatehabad"
  },
  "fatehgarh-sahib": {
    "city_name": "Fatehgarh Sahib",
    "city_slug": "fatehgarh-sahib"
  },
  "fatehpur": {
    "city_name": "Fatehpur",
    "city_slug": "fatehpur"
  },
  "fazilka": {
    "city_name": "Fazilka",
    "city_slug": "fazilka"
  },
  "firozabad": {
    "city_name": "Firozabad",
    "city_slug": "firozabad"
  },
  "gadag": {
    "city_name": "Gadag",
    "city_slug": "gadag"
  },
  "gadchiroli": {
    "city_name": "Gadchiroli",
    "city_slug": "gadchiroli"
  },
  "gajapati": {
    "city_name": "Gajapati",
    "city_slug": "gajapati"
  },
  "ganderbal": {
    "city_name": "Ganderbal",
    "city_slug": "ganderbal"
  },
  "garhwa": {
    "city_name": "Garhwa",
    "city_slug": "garhwa"
  },
  "gariaband": {
    "city_name": "Gariaband",
    "city_slug": "gariaband"
  },
  "giridh": {
    "city_name": "Giridh",
    "city_slug": "giridh"
  },
  "goalpara": {
    "city_name": "Goalpara",
    "city_slug": "goalpara"
  },
  "godda": {
    "city_name": "Godda",
    "city_slug": "godda"
  },
  "golaghat": {
    "city_name": "Golaghat",
    "city_slug": "golaghat"
  },
  "gomti": {
    "city_name": "Gomti",
    "city_slug": "gomti"
  },
  "gondia": {
    "city_name": "Gondia",
    "city_slug": "gondia"
  },
  "gumla": {
    "city_name": "Gumla",
    "city_slug": "gumla"
  },
  "guna": {
    "city_name": "Guna",
    "city_slug": "guna"
  },
  "hailakandi": {
    "city_name": "Hailakandi",
    "city_slug": "hailakandi"
  },
  "hapur": {
    "city_name": "Hapur",
    "city_slug": "hapur"
  },
  "harda": {
    "city_name": "Harda",
    "city_slug": "harda"
  },
  "hardoi": {
    "city_name": "Hardoi",
    "city_slug": "hardoi"
  },
  "hassan": {
    "city_name": "Hassan",
    "city_slug": "hassan"
  },
  "hathras": {
    "city_name": "Hathras",
    "city_slug": "hathras"
  },
  "haveri": {
    "city_name": "Haveri",
    "city_slug": "haveri"
  },
  "hingoli": {
    "city_name": "Hingoli",
    "city_slug": "hingoli"
  },
  "hisar": {
    "city_name": "Hisar",
    "city_slug": "hisar"
  },
  "hoshangabad": {
    "city_name": "Hoshangabad",
    "city_slug": "hoshangabad"
  },
  "idukki": {
    "city_name": "Idukki",
    "city_slug": "idukki"
  },
  "imphal-east": {
    "city_name": "Imphal East",
    "city_slug": "imphal-east"
  },
  "imphal-west": {
    "city_name": "Imphal West",
    "city_slug": "imphal-west"
  },
  "jagatsinghapur": {
    "city_name": "Jagatsinghapur",
    "city_slug": "jagatsinghapur"
  },
  "jaintia-hills": {
    "city_name": "Jaintia Hills",
    "city_slug": "jaintia-hills"
  },
  "jaisalmer": {
    "city_name": "Jaisalmer",
    "city_slug": "jaisalmer"
  },
  "jajapur": {
    "city_name": "Jajapur",
    "city_slug": "jajapur"
  },
  "jalaun": {
    "city_name": "Jalaun",
    "city_slug": "jalaun"
  },
  "jalna": {
    "city_name": "Jalna",
    "city_slug": "jalna"
  },
  "jamtara": {
    "city_name": "Jamtara",
    "city_slug": "jamtara"
  },
  "jamui": {
    "city_name": "Jamui",
    "city_slug": "jamui"
  },
  "jaribam": {
    "city_name": "Jaribam",
    "city_slug": "jaribam"
  },
  "jashpur": {
    "city_name": "Jashpur",
    "city_slug": "jashpur"
  },
  "jayashankar": {
    "city_name": "Jayashankar",
    "city_slug": "jayashankar"
  },
  "jehanabad": {
    "city_name": "Jehanabad",
    "city_slug": "jehanabad"
  },
  "jhabua": {
    "city_name": "Jhabua",
    "city_slug": "jhabua"
  },
  "jhalawar": {
    "city_name": "Jhalawar",
    "city_slug": "jhalawar"
  },
  "jharsuguda": {
    "city_name": "Jharsuguda",
    "city_slug": "jharsuguda"
  },
  "jind": {
    "city_name": "Jind",
    "city_slug": "jind"
  },
  "jorhat": {
    "city_name": "Jorhat",
    "city_slug": "jorhat"
  },
  "jyotiba-phule-nagar": {
    "city_name": "Jyotiba Phule Nagar",
    "city_slug": "jyotiba-phule-nagar"
  },
  "kabirdham": {
    "city_name": "Kabirdham",
    "city_slug": "kabirdham"
  },
  "kaimur": {
    "city_name": "Kaimur",
    "city_slug": "kaimur"
  },
  "kaithal": {
    "city_name": "Kaithal",
    "city_slug": "kaithal"
  },
  "kakching": {
    "city_name": "Kakching",
    "city_slug": "kakching"
  },
  "kalahandi": {
    "city_name": "Kalahandi",
    "city_slug": "kalahandi"
  },
  "kalimpong": {
    "city_name": "Kalimpong",
    "city_slug": "kalimpong"
  },
  "kamrup": {
    "city_name": "Kamrup",
    "city_slug": "kamrup"
  },
  "kandhamal": {
    "city_name": "Kandhamal",
    "city_slug": "kandhamal"
  },
  "kangpokpi": {
    "city_name": "Kangpokpi",
    "city_slug": "kangpokpi"
  },
  "kanker": {
    "city_name": "Kanker",
    "city_slug": "kanker"
  },
  "kannauj": {
    "city_name": "Kannauj",
    "city_slug": "kannauj"
  },
  "kanpur-dehat": {
    "city_name": "Kanpur Dehat",
    "city_slug": "kanpur-dehat"
  },
  "kanpur-nagar": {
    "city_name": "Kanpur Nagar",
    "city_slug": "kanpur-nagar"
  },
  "kapurthala": {
    "city_name": "Kapurthala",
    "city_slug": "kapurthala"
  },
  "karaikal": {
    "city_name": "Karaikal",
    "city_slug": "karaikal"
  },
  "karauli": {
    "city_name": "Karauli",
    "city_slug": "karauli"
  },
  "karbi-anglong": {
    "city_name": "Karbi Anglong",
    "city_slug": "karbi-anglong"
  },
  "kargil": {
    "city_name": "Kargil",
    "city_slug": "kargil"
  },
  "karimganj": {
    "city_name": "Karimganj",
    "city_slug": "karimganj"
  },
  "karur": {
    "city_name": "Karur",
    "city_slug": "karur"
  },
  "kasargod": {
    "city_name": "Kasargod",
    "city_slug": "kasargod"
  },
  "kathua": {
    "city_name": "Kathua",
    "city_slug": "kathua"
  },
  "katni": {
    "city_name": "Katni",
    "city_slug": "katni"
  },
  "kaushambi": {
    "city_name": "Kaushambi",
    "city_slug": "kaushambi"
  },
  "kawardha": {
    "city_name": "Kawardha",
    "city_slug": "kawardha"
  },
  "kendrapara": {
    "city_name": "Kendrapara",
    "city_slug": "kendrapara"
  },
  "kendujhar": {
    "city_name": "Kendujhar",
    "city_slug": "kendujhar"
  },
  "keonjhargarh": {
    "city_name": "Keonjhargarh",
    "city_slug": "keonjhargarh"
  },
  "khagaria": {
    "city_name": "Khagaria",
    "city_slug": "khagaria"
  },
  "khandwa": {
    "city_name": "Khandwa",
    "city_slug": "khandwa"
  },
  "khargone": {
    "city_name": "Khargone",
    "city_slug": "khargone"
  },
  "kheri": {
    "city_name": "Kheri",
    "city_slug": "kheri"
  },
  "khowai": {
    "city_name": "Khowai",
    "city_slug": "khowai"
  },
  "khunti": {
    "city_name": "Khunti",
    "city_slug": "khunti"
  },
  "kinnaur": {
    "city_name": "Kinnaur",
    "city_slug": "kinnaur"
  },
  "kiphire": {
    "city_name": "Kiphire",
    "city_slug": "kiphire"
  },
  "kishanganj": {
    "city_name": "Kishanganj",
    "city_slug": "kishanganj"
  },
  "kodagu": {
    "city_name": "Kodagu",
    "city_slug": "kodagu"
  },
  "koderma": {
    "city_name": "Koderma",
    "city_slug": "koderma"
  },
  "kohima": {
    "city_name": "Kohima",
    "city_slug": "kohima"
  },
  "kokrajhar": {
    "city_name": "Kokrajhar",
    "city_slug": "kokrajhar"
  },
  "kolar": {
    "city_name": "Kolar",
    "city_slug": "kolar"
  },
  "kolasib": {
    "city_name": "Kolasib",
    "city_slug": "kolasib"
  },
  "koppal": {
    "city_name": "Koppal",
    "city_slug": "koppal"
  },
  "koraput": {
    "city_name": "Koraput",
    "city_slug": "koraput"
  },
  "korba": {
    "city_name": "Korba",
    "city_slug": "korba"
  },
  "koriya": {
    "city_name": "Koriya",
    "city_slug": "koriya"
  },
  "kulgam": {
    "city_name": "Kulgam",
    "city_slug": "kulgam"
  },
  "kullu": {
    "city_name": "Kullu",
    "city_slug": "kullu"
  },
  "kupwara": {
    "city_name": "Kupwara",
    "city_slug": "kupwara"
  },
  "kurung-kumey": {
    "city_name": "Kurung Kumey",
    "city_slug": "kurung-kumey"
  },
  "lahul-spiti": {
    "city_name": "Lahul Spiti",
    "city_slug": "lahul-spiti"
  },
  "lakhimpur": {
    "city_name": "Lakhimpur",
    "city_slug": "lakhimpur"
  },
  "lakhisarai": {
    "city_name": "Lakhisarai",
    "city_slug": "lakhisarai"
  },
  "lakshadweep": {
    "city_name": "Lakshadweep",
    "city_slug": "lakshadweep"
  },
  "lalitpur": {
    "city_name": "Lalitpur",
    "city_slug": "lalitpur"
  },
  "latehar": {
    "city_name": "Latehar",
    "city_slug": "latehar"
  },
  "lawngtlai": {
    "city_name": "Lawngtlai",
    "city_slug": "lawngtlai"
  },
  "leh": {
    "city_name": "Leh",
    "city_slug": "leh"
  },
  "lohardaga": {
    "city_name": "Lohardaga",
    "city_slug": "lohardaga"
  },
  "lohit": {
    "city_name": "Lohit",
    "city_slug": "lohit"
  },
  "longding": {
    "city_name": "Longding",
    "city_slug": "longding"
  },
  "longleng": {
    "city_name": "Longleng",
    "city_slug": "longleng"
  },
  "lower-dibang-valley": {
    "city_name": "Lower Dibang Valley",
    "city_slug": "lower-dibang-valley"
  },
  "lower-subansiri": {
    "city_name": "Lower Subansiri",
    "city_slug": "lower-subansiri"
  },
  "lunglei": {
    "city_name": "Lunglei",
    "city_slug": "lunglei"
  },
  "morbi": {
    "city_name": "MORBI",
    "city_slug": "morbi"
  },
  "madhepura": {
    "city_name": "Madhepura",
    "city_slug": "madhepura"
  },
  "mahabubabad": {
    "city_name": "Mahabubabad",
    "city_slug": "mahabubabad"
  },
  "maharajganj": {
    "city_name": "Maharajganj",
    "city_slug": "maharajganj"
  },
  "mahasamund": {
    "city_name": "Mahasamund",
    "city_slug": "mahasamund"
  },
  "mahe": {
    "city_name": "Mahe",
    "city_slug": "mahe"
  },
  "mahendragarh": {
    "city_name": "Mahendragarh",
    "city_slug": "mahendragarh"
  },
  "mahoba": {
    "city_name": "Mahoba",
    "city_slug": "mahoba"
  },
  "mainpuri": {
    "city_name": "Mainpuri",
    "city_slug": "mainpuri"
  },
  "malkangiri": {
    "city_name": "Malkangiri",
    "city_slug": "malkangiri"
  },
  "mammit": {
    "city_name": "Mammit",
    "city_slug": "mammit"
  },
  "mandi": {
    "city_name": "Mandi",
    "city_slug": "mandi"
  },
  "mandla": {
    "city_name": "Mandla",
    "city_slug": "mandla"
  },
  "mandya": {
    "city_name": "Mandya",
    "city_slug": "mandya"
  },
  "mansa": {
    "city_name": "Mansa",
    "city_slug": "mansa"
  },
  "marigaon": {
    "city_name": "Marigaon",
    "city_slug": "marigaon"
  },
  "mau": {
    "city_name": "Mau",
    "city_slug": "mau"
  },
  "mayurbhanj": {
    "city_name": "Mayurbhanj",
    "city_slug": "mayurbhanj"
  },
  "medinipur": {
    "city_name": "Medinipur",
    "city_slug": "medinipur"
  },
  "moga": {
    "city_name": "Moga",
    "city_slug": "moga"
  },
  "mokokchung": {
    "city_name": "Mokokchung",
    "city_slug": "mokokchung"
  },
  "mon": {
    "city_name": "Mon",
    "city_slug": "mon"
  },
  "morena": {
    "city_name": "Morena",
    "city_slug": "morena"
  },
  "muktsar": {
    "city_name": "Muktsar",
    "city_slug": "muktsar"
  },
  "nabarangapur": {
    "city_name": "Nabarangapur",
    "city_slug": "nabarangapur"
  },
  "nagapattinam": {
    "city_name": "Nagapattinam",
    "city_slug": "nagapattinam"
  },
  "nalbari": {
    "city_name": "Nalbari",
    "city_slug": "nalbari"
  },
  "namakkal": {
    "city_name": "Namakkal",
    "city_slug": "namakkal"
  },
  "namsai": {
    "city_name": "Namsai",
    "city_slug": "namsai"
  },
  "narayanpur": {
    "city_name": "Narayanpur",
    "city_slug": "narayanpur"
  },
  "narmada": {
    "city_name": "Narmada",
    "city_slug": "narmada"
  },
  "narsinghpur": {
    "city_name": "Narsinghpur",
    "city_slug": "narsinghpur"
  },
  "nawada": {
    "city_name": "Nawada",
    "city_slug": "nawada"
  },
  "nawanshahr": {
    "city_name": "Nawanshahr",
    "city_slug": "nawanshahr"
  },
  "nayagarh": {
    "city_name": "Nayagarh",
    "city_slug": "nayagarh"
  },
  "neemuch": {
    "city_name": "Neemuch",
    "city_slug": "neemuch"
  },
  "nicobar": {
    "city_name": "Nicobar",
    "city_slug": "nicobar"
  },
  "nilgiris": {
    "city_name": "Nilgiris",
    "city_slug": "nilgiris"
  },
  "north-and-middle-andaman": {
    "city_name": "North And Middle Andaman",
    "city_slug": "north-and-middle-andaman"
  },
  "north-cachar-hills": {
    "city_name": "North Cachar Hills",
    "city_slug": "north-cachar-hills"
  },
  "north-sikkim": {
    "city_name": "North Sikkim",
    "city_slug": "north-sikkim"
  },
  "north-tripura": {
    "city_name": "North Tripura",
    "city_slug": "north-tripura"
  },
  "nuapada": {
    "city_name": "Nuapada",
    "city_slug": "nuapada"
  },
  "osmanabad": {
    "city_name": "Osmanabad",
    "city_slug": "osmanabad"
  },
  "pakur": {
    "city_name": "Pakur",
    "city_slug": "pakur"
  },
  "panna": {
    "city_name": "Panna",
    "city_slug": "panna"
  },
  "papum-pare": {
    "city_name": "Papum Pare",
    "city_slug": "papum-pare"
  },
  "parbhani": {
    "city_name": "Parbhani",
    "city_slug": "parbhani"
  },
  "pathankot": {
    "city_name": "Pathankot",
    "city_slug": "pathankot"
  },
  "pauri-garhwal": {
    "city_name": "Pauri Garhwal",
    "city_slug": "pauri-garhwal"
  },
  "peddapalli": {
    "city_name": "Peddapalli",
    "city_slug": "peddapalli"
  },
  "perambalur": {
    "city_name": "Perambalur",
    "city_slug": "perambalur"
  },
  "peren": {
    "city_name": "Peren",
    "city_slug": "peren"
  },
  "phek": {
    "city_name": "Phek",
    "city_slug": "phek"
  },
  "pilibhit": {
    "city_name": "Pilibhit",
    "city_slug": "pilibhit"
  },
  "pithoragarh": {
    "city_name": "Pithoragarh",
    "city_slug": "pithoragarh"
  },
  "poonch": {
    "city_name": "Poonch",
    "city_slug": "poonch"
  },
  "pudukkottai": {
    "city_name": "Pudukkottai",
    "city_slug": "pudukkottai"
  },
  "puri": {
    "city_name": "Puri",
    "city_slug": "puri"
  },
  "purulia": {
    "city_name": "Purulia",
    "city_slug": "purulia"
  },
  "raichur": {
    "city_name": "Raichur",
    "city_slug": "raichur"
  },
  "raisen": {
    "city_name": "Raisen",
    "city_slug": "raisen"
  },
  "rajanna-sircilla": {
    "city_name": "Rajanna Sircilla",
    "city_slug": "rajanna-sircilla"
  },
  "rajauri": {
    "city_name": "Rajauri",
    "city_slug": "rajauri"
  },
  "rajgarh": {
    "city_name": "Rajgarh",
    "city_slug": "rajgarh"
  },
  "rajnandgaon": {
    "city_name": "Rajnandgaon",
    "city_slug": "rajnandgaon"
  },
  "ramanagar": {
    "city_name": "Ramanagar",
    "city_slug": "ramanagar"
  },
  "ramanathapuram": {
    "city_name": "Ramanathapuram",
    "city_slug": "ramanathapuram"
  },
  "ramgarh": {
    "city_name": "Ramgarh",
    "city_slug": "ramgarh"
  },
  "rampur": {
    "city_name": "Rampur",
    "city_slug": "rampur"
  },
  "rayagada": {
    "city_name": "Rayagada",
    "city_slug": "rayagada"
  },
  "reasi": {
    "city_name": "Reasi",
    "city_slug": "reasi"
  },
  "rewari": {
    "city_name": "Rewari",
    "city_slug": "rewari"
  },
  "ri-bhoi": {
    "city_name": "Ri Bhoi",
    "city_slug": "ri-bhoi"
  },
  "rohtas": {
    "city_name": "Rohtas",
    "city_slug": "rohtas"
  },
  "ropar": {
    "city_name": "Ropar",
    "city_slug": "ropar"
  },
  "rudraprayag": {
    "city_name": "Rudraprayag",
    "city_slug": "rudraprayag"
  },
  "rupnagar": {
    "city_name": "Rupnagar",
    "city_slug": "rupnagar"
  },
  "saharsa": {
    "city_name": "Saharsa",
    "city_slug": "saharsa"
  },
  "sahibganj": {
    "city_name": "Sahibganj",
    "city_slug": "sahibganj"
  },
  "saiha": {
    "city_name": "Saiha",
    "city_slug": "saiha"
  },
  "sainkheda": {
    "city_name": "Sainkheda",
    "city_slug": "sainkheda"
  },
  "salem": {
    "city_name": "Salem",
    "city_slug": "salem"
  },
  "samba": {
    "city_name": "Samba",
    "city_slug": "samba"
  },
  "sambalpur": {
    "city_name": "Sambalpur",
    "city_slug": "sambalpur"
  },
  "sant-kabir-nagar": {
    "city_name": "Sant Kabir Nagar",
    "city_slug": "sant-kabir-nagar"
  },
  "sant-ravidas-nagar": {
    "city_name": "Sant Ravidas Nagar",
    "city_slug": "sant-ravidas-nagar"
  },
  "sawai-madhopur": {
    "city_name": "Sawai Madhopur",
    "city_slug": "sawai-madhopur"
  },
  "sehore": {
    "city_name": "Sehore",
    "city_slug": "sehore"
  },
  "senapati": {
    "city_name": "Senapati",
    "city_slug": "senapati"
  },
  "seoni": {
    "city_name": "Seoni",
    "city_slug": "seoni"
  },
  "sepahijala": {
    "city_name": "Sepahijala",
    "city_slug": "sepahijala"
  },
  "seraikela-kharsawan": {
    "city_name": "Seraikela-kharsawan",
    "city_slug": "seraikela-kharsawan"
  },
  "serchhip": {
    "city_name": "Serchhip",
    "city_slug": "serchhip"
  },
  "shahdol": {
    "city_name": "Shahdol",
    "city_slug": "shahdol"
  },
  "shajapur": {
    "city_name": "Shajapur",
    "city_slug": "shajapur"
  },
  "sheikhpura": {
    "city_name": "Sheikhpura",
    "city_slug": "sheikhpura"
  },
  "sheohar": {
    "city_name": "Sheohar",
    "city_slug": "sheohar"
  },
  "sheopur": {
    "city_name": "Sheopur",
    "city_slug": "sheopur"
  },
  "shivamogga": {
    "city_name": "Shivamogga",
    "city_slug": "shivamogga"
  },
  "shivpuri": {
    "city_name": "Shivpuri",
    "city_slug": "shivpuri"
  },
  "shopian": {
    "city_name": "Shopian",
    "city_slug": "shopian"
  },
  "shrawasti": {
    "city_name": "Shrawasti",
    "city_slug": "shrawasti"
  },
  "sibsagar": {
    "city_name": "Sibsagar",
    "city_slug": "sibsagar"
  },
  "siddharthnagar": {
    "city_name": "Siddharthnagar",
    "city_slug": "siddharthnagar"
  },
  "siddipet": {
    "city_name": "Siddipet",
    "city_slug": "siddipet"
  },
  "sidhi": {
    "city_name": "Sidhi",
    "city_slug": "sidhi"
  },
  "simdega": {
    "city_name": "Simdega",
    "city_slug": "simdega"
  },
  "sindhudurg": {
    "city_name": "Sindhudurg",
    "city_slug": "sindhudurg"
  },
  "singrauli": {
    "city_name": "Singrauli",
    "city_slug": "singrauli"
  },
  "sirmaur": {
    "city_name": "Sirmaur",
    "city_slug": "sirmaur"
  },
  "sitapur": {
    "city_name": "Sitapur",
    "city_slug": "sitapur"
  },
  "sivaganga": {
    "city_name": "Sivaganga",
    "city_slug": "sivaganga"
  },
  "sonapur": {
    "city_name": "Sonapur",
    "city_slug": "sonapur"
  },
  "sonbhadra": {
    "city_name": "Sonbhadra",
    "city_slug": "sonbhadra"
  },
  "south-andaman": {
    "city_name": "South Andaman",
    "city_slug": "south-andaman"
  },
  "south-garo-hills": {
    "city_name": "South Garo Hills",
    "city_slug": "south-garo-hills"
  },
  "south-sikkim": {
    "city_name": "South Sikkim",
    "city_slug": "south-sikkim"
  },
  "south-tripura": {
    "city_name": "South Tripura",
    "city_slug": "south-tripura"
  },
  "srikakulam": {
    "city_name": "Srikakulam",
    "city_slug": "srikakulam"
  },
  "surguja": {
    "city_name": "Surguja",
    "city_slug": "surguja"
  },
  "suryapet": {
    "city_name": "Suryapet",
    "city_slug": "suryapet"
  },
  "tiruppur": {
    "city_name": "TIRUPPUR",
    "city_slug": "tiruppur"
  },
  "tamenglong": {
    "city_name": "Tamenglong",
    "city_slug": "tamenglong"
  },
  "tapi": {
    "city_name": "Tapi",
    "city_slug": "tapi"
  },
  "tarn-taran": {
    "city_name": "Tarn Taran",
    "city_slug": "tarn-taran"
  },
  "tawang": {
    "city_name": "Tawang",
    "city_slug": "tawang"
  },
  "tehri-garhwal": {
    "city_name": "Tehri Garhwal",
    "city_slug": "tehri-garhwal"
  },
  "tengnoupal": {
    "city_name": "Tengnoupal",
    "city_slug": "tengnoupal"
  },
  "the-dangs": {
    "city_name": "The Dangs",
    "city_slug": "the-dangs"
  },
  "theni": {
    "city_name": "Theni",
    "city_slug": "theni"
  },
  "thoubal": {
    "city_name": "Thoubal",
    "city_slug": "thoubal"
  },
  "tikamgarh": {
    "city_name": "Tikamgarh",
    "city_slug": "tikamgarh"
  },
  "tinsukia": {
    "city_name": "Tinsukia",
    "city_slug": "tinsukia"
  },
  "tirap": {
    "city_name": "Tirap",
    "city_slug": "tirap"
  },
  "tirunelveli": {
    "city_name": "Tirunelveli",
    "city_slug": "tirunelveli"
  },
  "tiruvannamalai": {
    "city_name": "Tiruvannamalai",
    "city_slug": "tiruvannamalai"
  },
  "tiruvarur": {
    "city_name": "Tiruvarur",
    "city_slug": "tiruvarur"
  },
  "tonk": {
    "city_name": "Tonk",
    "city_slug": "tonk"
  },
  "tuensang": {
    "city_name": "Tuensang",
    "city_slug": "tuensang"
  },
  "tumakuru": {
    "city_name": "Tumakuru",
    "city_slug": "tumakuru"
  },
  "tuticorin": {
    "city_name": "Tuticorin",
    "city_slug": "tuticorin"
  },
  "udhampur": {
    "city_name": "Udhampur",
    "city_slug": "udhampur"
  },
  "udupi": {
    "city_name": "Udupi",
    "city_slug": "udupi"
  },
  "ukhrul": {
    "city_name": "Ukhrul",
    "city_slug": "ukhrul"
  },
  "umaria": {
    "city_name": "Umaria",
    "city_slug": "umaria"
  },
  "una": {
    "city_name": "Una",
    "city_slug": "una"
  },
  "upper-siang": {
    "city_name": "Upper Siang",
    "city_slug": "upper-siang"
  },
  "upper-subansiri": {
    "city_name": "Upper Subansiri",
    "city_slug": "upper-subansiri"
  },
  "uttara-kannada": {
    "city_name": "Uttara Kannada",
    "city_slug": "uttara-kannada"
  },
  "uttarkashi": {
    "city_name": "Uttarkashi",
    "city_slug": "uttarkashi"
  },
  "vijayapura": {
    "city_name": "Vijayapura",
    "city_slug": "vijayapura"
  },
  "villupuram": {
    "city_name": "Villupuram",
    "city_slug": "villupuram"
  },
  "virudhunagar": {
    "city_name": "Virudhunagar",
    "city_slug": "virudhunagar"
  },
  "washim": {
    "city_name": "Washim",
    "city_slug": "washim"
  },
  "wayanad": {
    "city_name": "Wayanad",
    "city_slug": "wayanad"
  },
  "west-garo-hills": {
    "city_name": "West Garo Hills",
    "city_slug": "west-garo-hills"
  },
  "west-kameng": {
    "city_name": "West Kameng",
    "city_slug": "west-kameng"
  },
  "west-khasi-hills": {
    "city_name": "West Khasi Hills",
    "city_slug": "west-khasi-hills"
  },
  "west-siang": {
    "city_name": "West Siang",
    "city_slug": "west-siang"
  },
  "west-sikkim": {
    "city_name": "West Sikkim",
    "city_slug": "west-sikkim"
  },
  "west-singhbhum": {
    "city_name": "West Singhbhum",
    "city_slug": "west-singhbhum"
  },
  "wokha": {
    "city_name": "Wokha",
    "city_slug": "wokha"
  },
  "yadgir": {
    "city_name": "Yadgir",
    "city_slug": "yadgir"
  },
  "yamuna-nagar": {
    "city_name": "Yamuna Nagar",
    "city_slug": "yamuna-nagar"
  },
  "zunhebotto": {
    "city_name": "Zunhebotto",
    "city_slug": "zunhebotto"
  },
  "noida": {
    "city_name": "Noida",
    "city_slug": "noida"
  },
  "gurugram": {
    "city_name": "Gurugram",
    "city_slug": "gurugram"
  }
};

export const administrationRoute = {
  EXTERNAL: ["CONDOM"],
  INHALATION: ["INHALER", "MD INHALER", "TRANSHALER", "RESPICAPS", "RESPULES"],
  "MEDICAL USE": ["SURGICALS", "DEVICE", "NEEDLES", "SYRINGE"],
  NASAL: ["NASAL SPRAY"],
  "NON-CONSUMABLE": [
    "GLOVES",
    "DIAPER",
    "MASK",
    "BELT",
    "PADS",
    "PEN",
    "BAG",
    "LANCET",
    "BANDAGE",
  ],
  "NOT APPLICABLE": ["KIT", "DROPS", "SUPPOSITORY"],
  ORAL: [
    "TABLET",
    "SYRUP",
    "SACHET",
    "CAPSULE",
    "GUMMIES",
    "SUSPENSION",
    "BISCUITS",
    "HONEY",
    "LIQUID",
    "WATER",
    "GRANULES",
    "FLOSS",
    "BRUSH",
    "STRIP",
    "MOUTHWASH",
  ],
  PARENTERAL: ["INJECTION"],
  TOPICAL: [
    "TOOTHPASTE",
    "GUM PAINT",
    "SOLUTION",
    "POWDER",
    "CREAM",
    "GEL",
    "SOAP",
    "LOTION",
    "HAND WASH",
    "HAIR COLOUR",
    "PASTE",
    "OINTMENT",
    "BALM",
    "SANITIZER",
    "SERUM",
    "BABY RUB",
    "WIPES",
    "BODYWASH",
    "FACE WASH",
    "SHAMPOO",
    "BUDS",
    "SPRAY",
    "OIL",
  ],
  TRANSDERMAL: ["PATCH"],
};
